<div class="content">
	Installeer deze app op uw telefoon.<br>
	Selecteerd het delen icon en dan<br>
	<strong>Toevoegen aan startscherm</strong>.
	<div class="full-width"><mat-icon>arrow_downward</mat-icon></div>
</div>
<button class="btn-close" mat-icon-button (click)="close()" aria-label="Close">
	<mat-icon>close</mat-icon>
</button>
